<template>
    <div class="project-highlight-section">
        <v-container>
            <v-row>
                <!-- Left Content -->
                <v-col cols="12" md="5" class="mb-6 mb-md-0">
                    <div class="highlight-content">
                        <h2 class="highlight-title">ห้องเรียน</h2>
                        <p class="highlight-description">
                            การออกแบบห้องเรียนที่เน้นความปลอดภัย
                            ความยืดหยุ่น และบรรยากาศการเรียนรู้ที่สร้างสรรค์
                            ในทุกวัย ประกอบด้วย การจัดวางพื้นที่ เช่น แสงธรรมชาติ
                            การเลือกวัสดุที่ไม่เป็นอันตราย เฟอร์นิเจอร์ที่ปรับเปลี่ยน
                            ได้ และการใช้สีช่วยกระตุ้นจินตนาการ และผสมผสาน
                            กับพัฒนาการของเด็กและช่วยให้ครูสามารถสอนด้วย
                            วิธีการหลากหลายได้อย่างมีประสิทธิภาพ
                        </p>

                        <button class="more-btn">
                            เพิ่มเติม
                        </button>

                        <!-- Small Thumbnail -->
                        <div class="thumbnail-wrapper">
                            <v-img src="https://placehold.co/400x300" alt="Classroom Thumbnail" class="thumbnail-image"
                                height="192" cover />
                        </div>
                        <p class="thumbnail-caption">แบบห้องเรียน</p>
                    </div>
                </v-col>

                <!-- Right Large Image -->
                <v-col cols="12" md="7">
                    <div class="highlight-image-wrapper">
                        <v-img src="https://placehold.co/800x600" alt="Classroom Main" class="main-image" height="500"
                            cover />
                    </div>
                    <p class="image-caption">ห้องเรียนสำหรับเด็ก</p>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
export default {
    name: "ProjectHighlight",
};
</script>

<style scoped>
.project-highlight-section {
    max-width: 1440px;
    margin: 0 auto;
    box-sizing: border-box;
    padding: 64px 0;
}

.highlight-content {
    display: flex;
    flex-direction: column;
    padding-right: 24px;
}

.highlight-title {
    font-size: 30px;
    font-weight: 700;
    color: #1f2937;
    margin-bottom: 24px;
}

.highlight-description {
    color: #4b5563;
    font-size: 16px;
    line-height: 1.625;
    margin-bottom: 24px;
}

.more-btn {
    background-color: #000000;
    color: #ffffff;
    padding: 8px 24px;
    border-radius: 9999px;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    border: none;
    align-self: flex-start;
    transition: background-color 0.2s;
    margin-bottom: 32px;
}

.more-btn:hover {
    background-color: #1f2937;
}

.thumbnail-wrapper {
    position: relative;
    width: 75%;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
}

.thumbnail-caption {
    font-size: 12px;
    color: #6b7280;
    margin-top: 8px;
}

.highlight-image-wrapper {
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);
}

.image-caption {
    font-size: 12px;
    color: #6b7280;
    margin-top: 8px;
}

@media (max-width: 768px) {
    .project-highlight-section {
        padding: 36px 0;
    }

    .highlight-content {
        padding-right: 0;
    }

    .highlight-title {
        font-size: 22px;
        margin-bottom: 14px;
    }

    .highlight-description {
        font-size: 14px;
        margin-bottom: 16px;
    }

    .thumbnail-wrapper {
        width: 100%;
    }

    .highlight-image-wrapper :deep(.v-image) {
        height: 240px !important;
    }
}
</style>
